import gql from "graphql-tag";

export default gql`
  query FinancialsSeries(
    $vertical: PlatformVertical!
    $statementType: FinancialsStatementType!
    $currency: String!
    $indicatorDataSource: IndicatorDataSource!
    $indicators: [IndicatorID!]!
    $securities: [FinancialsSeriesSecurityInput!]!
    $limit: Int!
    $filterByInterim: String
  ) {
    financialsSeries(
      vertical: $vertical
      statementType: $statementType
      currency: $currency
      indicatorDataSource: $indicatorDataSource
      indicators: $indicators
      securities: $securities
      limit: $limit
      filterByInterim: $filterByInterim
    ) {
      series {
        tickerSymbol
        reportDates
        indicators {
          objectId
          documentation {
            languageCode
            name
            abbreviation
            description
          }
          series {
            formattedValue
            ... on FinancialIndicatorSeriesFinancialNode {
              value
            }
            ... on FinancialIndicatorSeriesCurrencyNode {
              value
            }
            ... on FinancialIndicatorSeriesNumberNode {
              value
            }
            ... on FinancialIndicatorSeriesPercentNode {
              value
            }
            ... on FinancialIndicatorSeriesRatioNode {
              value
            }
            ... on FinancialIndicatorSeriesMetricNode {
              value
            }
            ... on FinancialIndicatorSeriesTextNode {
              text
            }
          }
        }
      }
    }
  }
`;
